var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 80,
    viewBox: "0 0 120 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    rx: 4,
    fill: "url(#paint0_linear_823_812)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.0264 65H83.0264",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.853 65H61.853",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6797 65H40.6797",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5063 65H19.5063",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.173 23.9866H18.8396C15.8941 23.9866 13.5063 26.3744 13.5063 29.3199V38.6533C13.5063 41.5988 15.8941 43.9866 18.8396 43.9866H32.173C35.1185 43.9866 37.5063 41.5988 37.5063 38.6533V29.3199C37.5063 26.3744 35.1185 23.9866 32.173 23.9866Z",
    fill: "#EDEDED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5198 24.9999V42.9999M22.5198 36.9999H14.5198M36.5198 36.9999H28.5198M22.5198 30.9999H14.5198M36.4931 30.9999H28.2531V43.0533M18.8398 24.6533H32.1731C34.7504 24.6533 36.8398 26.7426 36.8398 29.3199V38.6533C36.8398 41.2306 34.7504 43.3199 32.1731 43.3199H18.8398C16.2624 43.3199 14.1731 41.2306 14.1731 38.6533V29.3199C14.1731 26.7426 16.2624 24.6533 18.8398 24.6533Z",
    stroke: "black",
    strokeWidth: 1.333
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.493 15H92.4932",
    stroke: "#EDEDED",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_823_812",
    x1: 34.9333,
    y1: 15.4667,
    x2: 54.9376,
    y2: 59.9923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardGeneric);
export default __webpack_public_path__ + "static/media/card-generic.cb4c5d365f5540d442b6c3da4d64354c.svg";
export { ForwardRef as ReactComponent };